<template>
  <div class="content">
      <div class="block block-rounded block-fx-shadow mb-3">
        <div class="block-header">
          <h3 class="block-title">{{ $t('whitelistip.index') }}</h3>
          <div class="block-options">
            <b-btn v-b-modal.addwhitelistip size="sm" variant="primary" class="float-right">{{ $t('whitelistip.add') }}</b-btn>
          </div>
        </div>
        <div class="table-responsive-xl">
          <table class="table table-bordered  table-hover display">
            <thead>
              <tr>
                <th>#</th>
                <th>{{ $t('whitelistip.ip_address') }}</th>
                <th>{{ $t('whitelistip.ban') }}</th>
                <th>{{ $t('app.desc') }}</th>
                <th>{{ $t('app.action') }}</th>
              </tr>
            </thead>
            <tbody>
              <template v-if="!loadWhitelistips">
                <tr v-for="(whitelistip, index) in whitelistips" :key="whitelistip.id">
                  <td>{{index+1}}</td>
                  <td>{{whitelistip.ip_address}}</td>
                  <td>{{whitelistip.locked}}</td>
                  <td>{{whitelistip.description}}</td>
                  <td>
                    <div class="btn-group" role="group" aria-label="btnGroup1">
                      <button @click.prevent="initUpdate(index)" class="btn btn-primary btn-sm" title="Редактировать">
                        <i class="fa fa-edit"></i>
                      </button>
                      <button @click.prevent="handleDelete(whitelistip.id)" class="btn btn-danger btn-sm " :disabled="isProcessing" title="Удалить">
                        <i class="fa fa-times-circle"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              </template>
              <tr class="text-center" v-if="loadWhitelistips">
                <td colspan="5">
                  <loader-wave/>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div><!-- end card-->

      <b-modal id="addwhitelistip" size="lg" :title="$t('whitelistip.add')" ref="modalAddWhitelistip" @ok="handleStore" @shown="fetchWhitelistips" :ok-title="$t('buttons.ok')" :cancel-title="$t('buttons.cancel')">
          <div class="form-group">
              <label for="UpdateName" class="col-form-label">{{ $t('whitelistip.ip_address') }}</label>
              <input type="text" class="form-control" v-model="whitelistip.ip_address" :class="{'is-invalid': errors.ip_address }" id="updateip_address">
              <span v-if="errors.ip_address" class="invalid-feedback">
                  <strong>{{errors.ip_address ? errors.ip_address[0] : '' }}</strong>
              </span>
          </div>
          <div class="form-group">
              <label for="updatedescription" class="col-form-label">{{ $t('app.desc') }}</label>
              <input type="text" class="form-control" v-model="whitelistip.description" :class="{'is-invalid': errors.description }" id="updatedescription">
              <span v-if="errors.description" class="invalid-feedback">
                  <strong>{{errors.description ? errors.description[0] : '' }}</strong>
              </span>
          </div>
      </b-modal>

      <b-modal id="updatewhitelistip" size="lg" :title="$t('whitelistip.edit')" ref="modalUpdateWhitelistip" @ok="handleUpdate" @shown="fetchWhitelistips" :ok-title="$t('buttons.save')" :cancel-title="$t('buttons.cancel')">
          <div class="form-group">
              <label for="UpdateName" class="col-form-label">{{ $t('whitelistip.ip_address') }}</label>
              <input type="text" class="form-control" v-model="update_whitelistip.ip_address" :class="{'is-invalid': update_errors.ip_address }" id="updateip_address">
              <span v-if="update_errors.ip_address" class="invalid-feedback">
                  <strong>{{update_errors.ip_address ? update_errors.ip_address[0] : '' }}</strong>
              </span>
          </div>
          <div class="form-group">
              <label for="updatedescription" class="col-form-label">{{ $t('app.desc') }}</label>
              <input type="text" class="form-control" v-model="update_whitelistip.description" :class="{'is-invalid': update_errors.description }" id="updatedescription">
              <span v-if="update_errors.description" class="invalid-feedback">
                  <strong>{{update_errors.description ? update_errors.description[0] : '' }}</strong>
              </span>
          </div>
      </b-modal>

  </div>
</template>

<script>
export default {
  data() {
    return {
      whitelistips: [],
      whitelistip: {
        ip_address: '',
        locked: false,
        description: '',
      },
      errors: {},
      update_errors: {},
      update_whitelistip: {},
      isProcessing: false,
      loadWhitelistips: false,
    };
  },
  mounted() {
    this.fetchWhitelistips();
  },
  methods: {
    fetchWhitelistips() {
      this.loadWhitelistips = true;
      window.axios.get('/admin/whitelistips')
        .then((res) => {
          this.whitelistips = res.data.whitelistips;
          this.loadWhitelistips = false;
        });
    },

    clearStoreModal() {
      this.whitelistip.ip_address = '';
      this.whitelistip.locked = '';
      this.whitelistip.description = '';
    },

    clearUpdateModal() {
      this.update_whitelistip = {};
    },

    initUpdate(index) {
      this.update_errors = {};
      this.update_whitelistip = this.whitelistips[index];
      this.$refs.modalUpdateWhitelistip.show();
    },

    handleStore(evt) {
      evt.preventDefault();
      this.storeWhitelistIp();
    },

    handleUpdate(evt) {
      evt.preventDefault();
      this.updateWhitelistIp();
    },

    handleDelete(id) {
      window.Swal.fire({
        title: this.$t('alerts.are_you_sure'),
        text: this.$t('alerts.want_to_delete'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('alerts.delete_it'),
        cancelButtonText: this.$t('field.cancel'),
      }).then((result) => {
        if (result.value) {
          this.deleteWhitelistIp(id);
        }
      });
    },

    storeWhitelistIp() {
      this.isProcessing = true;
      window.axios.post('/admin/whitelistips', this.whitelistip)
        .then((res) => {
          this.$refs.modalAddWhitelistip.hide();
          window.Swal.fire(this.$t('alerts.success'), res.data.message, 'success');
          this.clearStoreModal();
          this.fetchWhitelistips();
        })
        .catch((err) => {
          this.errors = this.laravelValidation(err);
        })
        .finally(() => {
          this.isProcessing = false;
        });
    },

    updateWhitelistIp() {
      this.update_errors = {};
      this.isProcessing = true;
      window.axios.put(`/admin/whitelistips/${this.update_whitelistip.id}`, this.update_whitelistip)
        .then((res) => {
          if (res.status === 200) {
            this.$refs.modalUpdateWhitelistip.hide();
            window.Swal.fire(this.$t('alerts.success'), res.data.message, 'success');
            this.clearUpdateModal();
            this.fetchWhitelistips();
          }
        })
        .catch((err) => {
          this.update_errors = this.laravelValidation(err);
        })
        .finally(() => {
          this.isProcessing = false;
        });
    },

    deleteWhitelistIp(id) {
      this.isProcessing = true;
      window.axios.delete(`/admin/whitelistips/${id}`)
        .then((res) => {
          if (res.status === 204) {
            window.Swal.fire(this.$t('alerts.success'), res.data.message, 'success');
            this.fetchWhitelistips();
          }
        })
        .finally(() => {
          this.isProcessing = false;
        });
    },
  },
};
</script>
